<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
        <template slot="bodyForm">
            <CLoader :pConfigLoad="ConfigLoad">
                <template slot="BodyFormLoad">
                    <form id="FormCartaporte" class="form-horizontal" method="post" autocomplete="off"
                        onSubmit="return false">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <nav>
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li class="nav-item" role="presentation">
                                                <button type="button" class="nav-link active" id="documento-tab" data-bs-toggle="tab" data-bs-target="#documento"
                                                    ref="doc-tab" role="tab" aria-controls="documento" aria-selected="true">
                                                    Documento
                                                    <span v-if="bndError[0]" class="badge ms-1 bg-danger"><i class="fas fa-exclamation" style="font-size: 9px;"></i></span>
                                                </button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <button type="button" class="nav-link" id="mercancias-tab" data-bs-toggle="tab" data-bs-target="#mercancias"
                                                    ref="merTab" role="tab" aria-controls="mercancias" aria-selected="false">
                                                    Mercancias
                                                    <span v-if="bndError[1]" class="badge ms-1 bg-danger"><i class="fas fa-exclamation" style="font-size: 9px;"></i></span>
                                                </button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <button type="button" class="nav-link" id="ubicaciones-tab" data-bs-toggle="tab" data-bs-target="#ubicaciones"
                                                    ref="ubi-tab" role="tab" aria-controls="ubicaciones" aria-selected="false">
                                                    Ubicaciones
                                                    <span v-if="bndError[2]" class="badge ms-1 bg-danger"><i class="fas fa-exclamation" style="font-size: 9px;"></i></span>
                                                </button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <button type="button" class="nav-link" id="figura-tab" data-bs-toggle="tab" data-bs-target="#figuratransporte"
                                                    ref="fig-tab" role="tab" aria-controls="figuratransporte" aria-selected="false">Figura
                                                    Transporte
                                                    <span v-if="bndError[3]" class="badge ms-1 bg-danger"><i class="fas fa-exclamation" style="font-size: 9px;"></i></span>
                                                </button>
                                            </li>

                                        </ul>
                                    </nav>

                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab-pane fade show active" id="documento" role="tabpanel"
                                             ref="doc-pane" aria-labelledby="documento-tab" tabindex="0">
                                            <div class="container-tab">
                                                <DocumentoForm 
                                                v-if="DataLoaded" 
                                                :pObjDocumento="ObjDocumento" 
                                                :pObjCliente="ObjCliente"
                                                :pObjFactura="ObjFactura"
                                                :pListaRelacionados="ListaRelacionados"
                                                :pListaConceptos="ListaConceptos"
                                                :DataInicial="DataInicial" 
                                                :poBtnSave="oBtnSave" 
                                                :pErrorvalidacion="errorvalidacion"
                                                ref="documento">
                                                </DocumentoForm>
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" id="mercancias" role="tabpanel"
                                            ref="merPane" aria-labelledby="mercancias-tab" tabindex="0">
                                            <div class="container-tab">
                                                <MercanciasForm
                                                v-if="DataLoaded"
                                                :pObjMercancias="ObjMercancias"
                                                :pListaMercancias="ListaMercancias"
                                                :pAutotransporte="Autotransporte"
                                                :DataInicial="DataInicial"
                                                :poBtnSave="oBtnSave"
                                                :pErrorvalidacion="errorvalidacion"
                                                ref="mercancias">
                                                </MercanciasForm>
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" id="ubicaciones" role="tabpanel"
                                             ref="ubi-pane" aria-labelledby="ubicaciones-tab" tabindex="0">
                                            <div class="container-tab">
                                                <UbicacionesForm
                                                v-if="DataLoaded"
                                                :pObjOrigen="ObjOrigen"
                                                :pListaDestinos="ListaDestinos"
                                                :poBtnSave="oBtnSave"
                                                :pErrorvalidacion="errorvalidacion"
                                                :DataInicial="DataInicial"
                                                :pHabIdUbicacion = "HabIdUbicacion"
                                                ref="ubicaciones">
                                                </UbicacionesForm>
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" id="figuratransporte" role="tabpanel"
                                             ref="fig-pane" aria-labelledby="figuratransporte-tab" tabindex="0">
                                            <div class="container-tab">
                                                <TransporteForm 
                                                v-if="DataLoaded"
                                                :pListaFiguras="ListaFiguras"
                                                :poBtnSave="oBtnSave"
                                                :pErrorvalidacion="errorvalidacion"
                                                :DataInicial="DataInicial"
                                                ref="figuras">
                                                </TransporteForm>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end">
                                        <div class="me-2">
                                            <select v-model="ObjCartaporte.Estatus" class="form-control form-select" style="width: 160px;">
                                                <option value="NO">Guardar</option>
                                                <option value="SI">Guardar y Facturar</option>
                                            </select>
                                        </div>
                                        <CBtnSave :poBtnSave="oBtnSave">
                                        </CBtnSave>
                                    </div>
                                </div><!--fin col-12-->
                            </div>
                        </div>
                    </form>
                </template>
            </CLoader>
        </template>
    </CList>
</template>
<script>

const EmitEjecuta = 'seccionCartaporte';
const SPINNER = 'spinner-border spinner-border-sm';
const MAGNIFIER = 'fa fa-search';
import Configs from '@/helpers/VarConfig.js';
import DocumentoForm from '@/views/modulos/finanzas/cartaporte/documento/Form.vue'
import MercanciasForm from '@/views/modulos/finanzas/cartaporte/mercancias/Form.vue'
import UbicacionesForm from '@/views/modulos/finanzas/cartaporte/ubicaciones/Form.vue'
import TransporteForm from '@/views/modulos/finanzas/cartaporte/figuratransporte/Form.vue'
import moment from 'moment';

export default {
    name: 'FormCartaporte',
    props: ['Obj','Id'],
    components: { DocumentoForm, MercanciasForm, UbicacionesForm, TransporteForm },
    data() {
        return {
            ConfigList: {
                Title: 'Carta Porte Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
                EmitSeccion: EmitEjecuta,
            },
            ConfigLoad: {
                ShowLoader: true,
                ClassLoad: false,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'cartaporte',
                EmitSeccion: EmitEjecuta,
            },
            ObjCartaporte: {
                IdCartaPorte:0,
                IdCotizacion:0,
                Estatus:'ss',
            },
            ObjDocumento:{
                IdCotizacion:0,
                TipoDocumento: '',
                TipoTransporte: '',
                TranspInternac: '',
                Folio:'',
                TotalDistRec: '',
                EntradaSalidaMerc: '', // Tipo de mercancia
                PaisOrigenDestino: '',
                ViaEntradaSalida: '',
            },
            ObjCliente:{
                IdCliente: '',
                IdAgente: '',
                NameInstitucion: '',     // Cliente
                RazonCliente: '',        // Razon cliente
                NombreComercial: '',     // Empresa
                CP: '',
                RFC: '',
                Estado: '',
                Ciudad: '',
                Municipio: '',
                Calle: '',
                NumExt: '',
                NumInt: '',
            },
            ObjFactura:{
                IdFactura:'',
                UsoCfdi:'',
                FormaPago:'',
                Moneda:'',
                //Resumen 
                SubTotal:'',
                Descuento:'',
                Iva:'',
                IvaRetencion:'',
                PcteIva:0.16,
                Total:'',
            },
            ObjMercancias: {
                PesoBrutoTotal: '',
                UnidadPeso: '',
                NumTotalMercancias: '',
                // Helpers
                Fraccion:false,
                HabPedimentos:false,
                TranspMatPelig:false,
            },
            Autotransporte: {
                HabilitaAF:true,
                IdAutotransporte: '',
                IdVehiculo: '',
                PermiteRemolque:false,
                // Identificacion vehicular
                PlacaVM: '',
                ConfigVehicular: '',
                AnioModeloVM: '',
                PesoBrutoVehicular: '',
                //SCT
                PermSCT: '',
                NumPermisoSCT: '',
                //Seguros
                AseguraRespCivil: '',
                PolizaRespCivil: '',
                AseguraMedAmbiente: '',
                PolizaMedAmbiente: '',
                AseguraCarga: '',
                PolizaCarga: '',
            },
            ObjOrigen:{
                chkOrigen: false,
                TipoUbicacion: 'Origen',
                RFCRemitDestinat: '',
                FechaHoraSalidaLlegada:'',
                IDUbicacion: '',
                NombreRemitDestinat: '',
                NumRegIdTrib: '',
                ResidenciaFiscal: '',
                Calle: '',
                NumeroExt: '',
                NumeroInt: '',
                Colonia: '',
                Localidad: '',
                Referencia: '',
                Municipio: '',
                Estado: '',
                Pais: '',
                CodigoPostal: '',
                IdContacto: 0,
                // Helpers
                FechaSalida: '',
                HoraSalida: '',
                ListaEstados: [],
                ListaMunicipios: [],
                ListaColonias: [],
                ListaLocalidad: [],
                AutoCompList: [],
                IconSearch: MAGNIFIER,
                DisableNumIdTributario: true,
                DisableResidenciaFiscal: true,
            },
            ListaMercancias:[],
            ListaDestinos:[],
            ListaConceptos:[],
            ListaRelacionados:[],
            ListaFiguras:[],
            ListaMerCanceladas:[],
            ListaFigCanceladas:[],
            // Helpers
            DataInicial:{},
            DataLoaded:false,
            HabIdUbicacion:false,
            bndError:[false, false, false, false],
            segurity: {},
            masks: { input: 'YYYY-MM-DD' }, 
            errorvalidacion: [],
            Emit: EmitEjecuta,
        }
    },
    methods:
    {
        async Guardar() {
            this.errorvalidacion = [];
            this.oBtnSave.Toast = 0;
            this.oBtnSave.DisableBtn = true;
            this.bndError=[false, false, false, false];

            let CartaporteObj = this.RecogerData();
           
            if (this.ValidarCartaporte(CartaporteObj)){
                const cartaPorteFD = this.ObjectToFormData(CartaporteObj);
                console.log(cartaPorteFD);
                // this.oBtnSave.DisableBtn = false;
                // return false;
                await this.$http.post(
                    'cpf_CartaPorte',
                    cartaPorteFD,{
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then((res) => {
                    this.EjecutaConExito(res);
                }).catch(err => {
                    this.EjecutaConError(err);
                });
            } else {
                this.oBtnSave.DisableBtn = false;
            }
            
        },
        EjecutaConExito(res) {
            this.oBtnSave.DisableBtn = false;
            this.bus.$emit('RunAlerts_' + this.Emit, 1);
            this.Regresar();
        },
        EjecutaConError(err) {
            this.oBtnSave.DisableBtn = false;
            if (err.response.data.typemsg == 2) {
                this.errorvalidacion = err.response.data.message;
                this.BuscarSeccionErr();
                this.oBtnSave.Toast = 2;
            }
            else {
                this.$toast.error(err.response.data.message);
            }
        },
        BuscarSeccionErr(){
            let secciones = [
                [this.ObjDocumento, this.ObjCliente, this.ObjFactura],
                [this.ObjMercancias, this.Autotransporte],
                [this.ObjOrigen],
                []
            ];
            secciones.forEach((seccion, index) => {
                seccion.forEach(Obj => {
                    Object.keys(this.errorvalidacion).forEach(err => {
                        if(Object.hasOwn(Obj, err)){
                            this.bndError[index] = true;
                        }
                    });
                })
            })
        },
        async Recuperar() {
            this.DataLoaded = false;
            this.ConfigLoad.ShowLoader = true;
            try {
                const res1 = await this.$http.get(
                    "cpDataCombosInicial",
                    // {params: {
                    //     IdCotizacion: this.ObjCartaporte.IdCotizacion,
                    // }}
                );

                this.DataInicial = res1.data.data;
                this.SetDataInicial();

                if (this.ObjCartaporte.IdCartaPorte > 0) {
                    const res2 = await this.$http.get("cpf_CartaPorte/"+this.ObjCartaporte.IdCartaPorte);
                    this.SetDataRecuperada(res2.data.data);
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.DataLoaded = true;
                this.ConfigLoad.ShowLoader = false;
            }
        },
        SetDataInicial(){     
            // this.ObjDocumento.Folio = this.DataInicial.cotizacion.NumCotizacion;
            // this.ObjDocumento.IdCotizacion =  this.DataInicial.cotizacion.IdCotizacionServicioCalibracion;
            
            // // ObjCliente
            // this.ObjCliente.NameInstitucion = this.DataInicial.cotizacion.NameInstitucion;
            // this.ObjCliente.IdCliente = this.DataInicial.cotizacion.IdInstitucion;

            // Funcion para rellenar la lista de los combos para Estado, Localidad, Municipio y Colonia
            this.DataInicial.getComboList = async function (ComboList,Tipo,Criterio,ScpThis) {
                let apiUrl = '';
                switch (Tipo) {
                    case 'estado': 
                        apiUrl = 'cpEstados';
                        break;
                    case 'municipio': 
                        apiUrl = 'cpMunicipios';
                        break;
                    case 'localidad': 
                        apiUrl = 'cpLocalidades';
                        break;
                    case 'colonia': 
                        apiUrl = 'cpColonias';
                        break;
                
                    default:
                        console.error('error: sin coincidencias para', Tipo)
                        break;
                }
                if(apiUrl){
                    await ScpThis.$http.get(apiUrl, {params:{
                        ClavePais:Tipo==='estado'?Criterio:undefined,
                        ClaveEstado:Tipo==='municipio'||Tipo==='localidad'?Criterio:Tipo==='colonia'?Criterio.Estado:undefined,
                        ClaveMunicipio:Tipo==='colonia'?Criterio.Municipio:undefined,
                        simple:true,
                    }}).then((res) => {
                        let resp = res.data.data;
                        resp.forEach(elem => {
                            ComboList.push(elem);
                        });
                    })
                }
                return true;
            }
        },
        SetDataRecuperada(data){
            // ObjCartaPorte
            this.ObjCartaporte.IdCartaPorte = data.CartaPorte.IdCartaPorte;
            this.ObjCartaporte.IdCotizacion = data.CartaPorte.IdContizacion;
            this.ObjCartaporte.Estatus = data.CartaPorte.Estatus;

            // Seccion Documento
            Object.keys(data.CartaPorte).forEach(elem =>{
                if(Object.hasOwn(this.ObjDocumento, elem)){
                    this.ObjDocumento[elem] = data.CartaPorte[elem];
                }
            })
            this.ObjFactura = {...data.Factura}
            this.ListaRelacionados = [...data.ListaRelacionados]
            this.ListaConceptos = [...data.ListaConceptos];
            this.ObjCliente.IdRazonCliente = data.Factura.IdRazonCliente;
            this.ObjCliente.RazonCliente = data.Factura.IdRazonCliente;
            this.ObjCliente.Empresa = data.Factura.NombreCliente;
            this.ObjCliente.RFC = data.Factura.RfcCliente;
            this.ObjCliente.CodigoPostal = data.Factura.CPCliente;
            this.ObjCliente.Estado = data.Factura.EstadoCliente;
            this.ObjCliente.Ciudad = data.Factura.CiudadCliente;
            this.ObjCliente.Colonia = data.Factura.ColoniaCliente;
            this.ObjCliente.Calle = data.Factura.CalleCliente;
            this.ObjCliente.NumExt = data.Factura.NumExtCliente;
            this.ObjCliente.NumInt = data.Factura.NumIntCliente;
    
            // Sección Mercancias
            this.ObjMercancias.UnidadPeso = data.CartaPorte.UnidadPeso;
            this.ObjMercancias.PesoBrutoTotal = data.CartaPorte.PesoBrutoTotal;
            this.ObjMercancias.NumTotalMercancias = data.CartaPorte.NumTotalMercancias;
            this.ListaMercancias = data.ListaMercancias;
            Object.keys(data.Autotransporte).forEach(elem =>{
                if(Object.hasOwn(this.Autotransporte,elem)){
                    this.Autotransporte[elem] = data.Autotransporte[elem];
                }
            })
            let ArrRemolques = [
                {
                    SubTipoRem: data.Autotransporte.SubTipoRem1,
                    Placa: data.Autotransporte.Placa1,
                },
                {
                    SubTipoRem: data.Autotransporte.SubTipoRem2,
                    Placa: data.Autotransporte.Placa2,
                }
            ]
            this.Autotransporte['ArrRemolques'] = [...ArrRemolques];

            // Sección ubicaciones
            Object.keys(data.Origen).forEach(elem =>{
                if(Object.hasOwn(this.ObjOrigen,elem)){
                    this.ObjOrigen[elem] = data.Origen[elem];
                }
            })
            this.ObjOrigen.chkOrigen = (data.Origen.TipoDestino === 'empr' ? true : false)
            // let origDate = new Date(Date.parse(data.Origen.FechaHoraSalidaLlegada));
            // this.ObjOrigen.FechaHoraSalidaLlegada = origDate;
            this.ListaDestinos = data.ListaDestinos;
            
            // Sección Figuras
            this.ListaFiguras = data.ListaFiguras;
        },
        HabilitarFraccion(TranspInter){
            if(TranspInter === 'SI'){
                this.ObjMercancias.Fraccion = true;
            } else {
                this.ObjMercancias.Fraccion = false;
            }
        },
        HabilitarPedimentos(EntSalMerc){
            if(EntSalMerc === 'Entrada'){
                this.ObjMercancias.HabPedimentos = true;
            } else {
                this.ObjMercancias.HabPedimentos = false;
            }
        },
        UpdateDistTotal(Dist){
            this.ObjDocumento.TotalDistRec = Dist;
        },
        HabilitarIdUbicacion(data){
            this.HabIdUbicacion = data;
        },
        Limpiar() {
            this.ObjCartaporte = {
                IdCotizacion: 0,
                IdCartaPorte: 0,
                Estatus:'NO',
            }
            this.errorvalidacion = [];
        },
        // Recolecta la data de los componentes hijos y los unifica en 1 objeto.
        RecogerData(){
            let ObjCombinado = {};

            // CATAPORTE
            let cartaP = this.ObjCartaporte;

            // SECCION DOCUMENTO
            let documento = this.$refs.documento.ObjDocumento;
            // Usamos un objeto vacío || {} por si ObjCliente es null/undefined
            let objClienteRef = this.$refs.documento.ObjCliente || {}; 

            let cliente = {
                // Si no existe IdAgente, le asignamos una cadena vacía '' para que FindEmptyField lo detecte como vacío
                IdCliente: objClienteRef.IdAgente !== undefined && objClienteRef.IdAgente !== null ? objClienteRef.IdAgente : '',
                Empresa: objClienteRef.NombreComercial || '',
                RFC: objClienteRef.RFC || '',
            };

            if (cliente.RFC == 'XAXX010101000'){
                cliente.IdCliente = 0;
            }
            let conceptos = {'ListaConceptos':this.$refs.documento.ListaConceptos};
            let factura = {...this.$refs.documento.ObjFactura};

            // SECCION MERCANCIAS
            let mercanciasObj =  this.$refs.mercancias.ObjMercancias;
            let mercancias = {'ListaMercancias':[...this.$refs.mercancias.ListaMercancias]};
            let mercsCanceladas = {'ListaMerCanceladas':[...this.$refs.mercancias.ListaMerCanceladas]};
            let autotransporte =  this.$refs.mercancias.Autotransporte;
            let remHelper = this.$refs.mercancias.ArrRemolques;
            let rems =  {'ArrRemolques':[...remHelper]};
            let remolques = {
                SubTipoRem1: remHelper[0] != undefined ? remHelper[0].SubTipoRem :'',
                Placa1: remHelper[0] != undefined ? remHelper[0].Placa :'',
                SubTipoRem2: remHelper[1] != undefined ? remHelper[1].SubTipoRem :'',
                Placa2: remHelper[1] != undefined ? remHelper[1].Placa :'',
            };

            // SECCION UBICACIONES
            let origen = this.$refs.ubicaciones.ObjOrigen;
            let destinos = {'ListaDestinos':[...this.$refs.ubicaciones.ListaDestinos]};
            
            
            // SECCION FIGURA TRANSPORTE
            let figuras = {'ListaFiguras':[...this.$refs.figuras.ListaFiguras]};
            let figsCanceladas = {'ListaFigCanceladas':[...this.$refs.figuras.ListaFigCanceladas]};

            Object.assign(ObjCombinado,
                cartaP, 
                documento,
                cliente,
                conceptos,
                factura,
                mercanciasObj,
                mercancias,
                autotransporte,
                rems,
                remolques,
                origen,
                destinos,
                figuras,
                mercsCanceladas,
                figsCanceladas,
            );

            // Se crea un deep clone para poder manipular y validar.
            ObjCombinado['HabilitaAutoTransporte'] = ObjCombinado.HabilitaAF === true ? 1 : 0;
            let FormatListaDetinos = ObjCombinado.ListaDestinos.map(dest => {
                let destFormat =  {...dest}
                let fechaFormato = moment(dest.FechaSalida).format('YYYY-MM-DD') + ' ' + dest.HoraSalida;
                destFormat.FechaHoraSalidaLlegada = fechaFormato
                    return destFormat;
            })
            let dcObjCombinado = JSON.parse(JSON.stringify(ObjCombinado));
            dcObjCombinado.chkOrigen = dcObjCombinado.chkOrigen ? 'SI':'NO';
            let fechaFormato =  moment(ObjCombinado.FechaSalida).format('YYYY-MM-DD') + ' ' + ObjCombinado.HoraSalida;
            dcObjCombinado.FechaHoraSalidaLlegada = fechaFormato;
            dcObjCombinado.ListaDestinos = FormatListaDetinos;

            // LIMPIEZA DEL OBJETO
            // Limpieza de combos helpers
            delete dcObjCombinado.ListaEstados;
            delete dcObjCombinado.ListaMunicipios;
            delete dcObjCombinado.ListaColonias;
            delete dcObjCombinado.ListaLocalidad;
            dcObjCombinado.ListaDestinos.forEach(elem => {
                delete elem.AutoCompList;
                delete elem.ListaEstados;
                delete elem.ListaMunicipios;
                delete elem.ListaColonias;
                delete elem.ListaLocalidad;
            });
            dcObjCombinado.ListaFiguras.forEach(elem => {
                delete elem.AutocompChoferList;
                delete elem.IconSearch;
                delete elem.Active;
                if (elem.ArrayPartes.length >= 1){
                    delete elem.ArrayPartes[0].Active;
                    delete elem.ArrayPartes[0].ListaEstados;
                    delete elem.ArrayPartes[0].ListaMunicipios;
                    delete elem.ArrayPartes[0].ListaColonias;
                    delete elem.ArrayPartes[0].ListaLocalidad;
                }
            });
            return dcObjCombinado;
        },
        ValidarCartaporte(Obj){
            let validacion;
            if(!this.ValidarSeccionDocumento(Obj)){
                this.bndError[0] = true;
                validacion = false;
            } else if (!this.ValidarConceptos(Obj.ListaConceptos)){
                this.bndError[0] = true;
                validacion =  false;
            } else if(!this.ValidarDatosFactura(Obj)) {
                this.bndError[0] = true;
                validacion = false;
            } else if (!this.ValidarMercancias(Obj,Obj.ListaMercancias)){
                this.bndError[1] = true;
                validacion =  false;
            }else if(!this.ValidarConfiguracionVehicular(Obj)){
                validacion = false;
                this.bndError[1] = true;
            } else if (!this.ValidarOrigenDestinos(Obj,Obj.ListaDestinos)){
                this.bndError[2] = true;
                validacion =  false;
            } else if (!this.ValidarFiguras(Obj.ListaFiguras)){
                this.bndError[3] = true;
                validacion = false;
            } else {
                validacion = true;
            }
            
            return validacion;
            // return true;
        },
        ValidarSeccionDocumento(obj){
            let valido = true;
            let entries = {
                TipoDocumento:'Tipo de Documento',
                TipoTransporte:'Tipo de Transporte',
                TranspInternac:'Transporte Intenacional',
                IdCliente: 'Cliente'
            } 
            if (obj.TranspInternac==='SI'){
                entries = {...entries,
                EntradaSalidaMerc:'Tipo de Mercancia',
                PaisOrigenDestino:'Pais de Origen/Destino',
                ViaEntradaSalida:'Via de Entrada/Salida ',
                }
            }
            let campoVacio = this.FindEmptyField(obj, entries)
            
            if(campoVacio){
                valido = false;
                let msg = `El campo ${entries[campoVacio]} es obligatorio.`;
                this.$toast.error(msg);
            } 
            return valido;
        },
        ValidarConfiguracionVehicular(obj){
            let valido = true;
            if(!obj.HabilitaAF){
                return valido;
            }
            // VALIDACION REMOLQUES
            let remValido = true;
            obj.ArrRemolques.every(elem =>{
                if(elem.Placa.trim() === '' || elem.SubTipoRem.trim() === ''){
                    remValido = false;
                }
                return remValido;
            })
            let entries = {
                UnidadPeso:'Unidad Peso',
                PlacaVM:'Placa VM',
                ConfigVehicular:'Configuración Vehicular',
                AnioModeloVM:'Año Modelo VM',
                PesoBrutoVehicular:'Peso Bruto Vehicular',
                PermSCT:'Permiso SCT',
                NumPermisoSCT:'Número Permiso SCT',
                AseguraRespCivil: 'Nombre Aseguradora',
                PolizaRespCivil: 'N° Poliza Aseguradora',
            } 
            if (obj.TranspMatPelig){
                entries = {...entries,
                    AseguraMedAmbiente:'Asegura Medio Ambiente',
                    PolizaMedAmbiente:'Póliza Medio Ambiente',
                }
            }
            if(true){
                entries = {...entries,
                AseguraCarga: 'Aseguradora Carga',
                PolizaCarga: 'Póliza Carga',
                }
            }
            let campoVacio = this.FindEmptyField(obj, entries)
            
            if(campoVacio){
                valido = false;
                let msg = `El campo ${entries[campoVacio]} es obligatorio.`;
                this.$toast.error(msg);
            } else if(obj.PermiteRemolque && obj.ArrRemolques.length <= 0){
                this.$swal(Configs.configMinRemolques);
                valido = false;
            } else if (!remValido){
                let warn = {...Configs.configMinRemolques};
                warn.title = 'Complete todos los campos de remolques';
                warn.text='';
                this.$swal(warn);
                valido = false;
            } 
            return valido;
        },
        ValidarDatosFactura(Obj){
            let valido = true;
            
            let entries = {}
            if(Obj.TipoDocumento === 'I'){
                entries = {...entries,
                    CondicionesPago:'Condicion pago',
                    FormaPago: 'Forma de pago',
                    Moneda: 'Moneda',
                    MetodoPago: 'Metodo de pago',
                    UsoCfdi: 'USO CFDI',
                    TipoCambio: 'Tipo de Cambio',
                }
            }
            let docRelVacio = Obj.ListaRelacionados.findIndex(elem => {
                let id = elem.IdDocumentoRelacionado.trim();
                let tipoRel = elem.TipoRelacionCFDI.trim();
                return (id==='' || tipoRel==='')
            })
            let campoVacio = this.FindEmptyField(Obj, entries)
            if(campoVacio){
                valido = false;
                let msg = `Error en sección factura: el campo ${entries[campoVacio]} es obligatorio.`;
                this.$toast.error(msg);
            } else if(docRelVacio>=0){
                valido = false;
                this.$toast.error('Complete los campos en Documentos Relacionados '+(docRelVacio+1))
            }

            return valido;
        },
        ValidarOrigenDestinos(Obj,Destinos){
            let valido = true;
            const RFC_GENERICO = 'XEXX010101000';
            let errorObj = {
                seccion:'',
                index:0,
                campo:'',
            };

            // Campos obligatorios
            let entries = {
                TipoUbicacion:           'Tipo de ubicación',
                RFCRemitDestinat:        'RFC Remitente',
                FechaSalida:             'Fecha',
                HoraSalida:              'Hora',
                NombreRemitDestinat:     'Nombre Remitente',
                CodigoPostal:            'Código postal',
                Pais:                    'País',
                Estado:                  'Estado',
                // Calle:                   'Calle',
                // NumeroExt:               'Número exterior',
                // Colonia:                 'Colonia',
                // Municipio:               'Municipio',
            }

            // Campos obligatorios condicionales
            if(this.HabIdUbicacion){
                entries['IDUbicacion'] = 'Id Ubicacón';
            }

            // Campos vacios en origen
            let CamposOrigen = {...entries};
            if(Obj.RFCRemitDestinat === RFC_GENERICO){
                CamposOrigen['ResidenciaFiscal'] = 'Residencia fiscal';
                CamposOrigen['NumRegIdTrib'] = 'N° Registro IdTributario';
            }
            let campoVacio = this.FindEmptyField(Obj, CamposOrigen)

            if(campoVacio){
                errorObj.seccion = 'Origen',
                errorObj.index = '',
                errorObj.campo = CamposOrigen[campoVacio],
                valido = false;
            } else if(Destinos.length <= 0){
                this.$swal(Configs.configMinDestinos);
                valido = false;
            } else {
                // Campos obligatorios para los Destinos
                delete entries.TipoUbicacion;
                entries['TipoDestino'] = 'Tipo de ubicacion'
                entries.RFCRemitDestinat = 'RFC Destinatario'
                entries.NombreRemitDestinat = 'El nombre Destinatario'
                if(Obj.HabilitaAF){
                    entries['DistanciaRecorrida'] = 'Distancia recorrida';
                }

                Destinos.every((elem, idx) => {
                    errorObj.index = idx+1;
                    let Campos = {...entries}
                    // Campos obligatorios si el RFC es extranjero/generico
                    if(elem.RFCRemitDestinat === RFC_GENERICO){
                        Campos['ResidenciaFiscal'] = 'Residencia fiscal';
                        Campos['NumRegIdTrib'] = 'N° Registro IdTributario';
                    }
                    
                    let campoVacio =  this.FindEmptyField(elem, Campos);
                    if(campoVacio){
                        errorObj.campo = Campos[campoVacio];
                        errorObj.seccion = 'destino',
                        valido =  false;
                    }
                    return valido;
               })
            }
            if(errorObj.campo != ''){
                let msg = `Error en ${errorObj.seccion} ${errorObj.index}: el campo ${errorObj.campo} es obligatorio.`;
                this.$toast.error(msg);
            }
            return valido;
        },
        ValidarMercancias(Obj, Mercancias) {
            let valido = true;
            let errorObj = {
                index: 0,
                campo: '',
            };

            let entries = {
                BienesTransp:   'Bienes transportados',
                Cantidad: 'Cantidad',
                ClaveUnidad: 'Clave unidad',
                Descripcion: 'Descripción',
                ValorMercancia: 'Valor mercancia',
                Moneda: 'Moneda',
                Dimensiones: 'Dimensiones',
                MaterialPeligroso: 'Transporta material peligroso',
            }
            let entriesPedimentos = {
                Pedimento: 'Pedimento',
            }

            let entriesGuias = {
                NumeroGuiaIdentificacion: 'Numero guía de indentificación',
                PesoGuiaIdentificacion: 'Peso guía identificación',
                DescripGuiaIdentificacion: 'Desccripción guía identificación',
            }
            
            let entriesCantTransp = {
                CantidadM: 'Cantidad (Cantidad Transporta)',
                IDOrigen: 'ID Origen',
                IDDestino: 'Id Destino',
            }
            
            if(Obj.HabilitaAF){
                entries['PesoEnKg'] = 'Peso en Kgs';
            }
            if (Obj.Fraccion) {
                entries['FraccionArancelaria'] = 'Fracción Arancelaria';
            }
            
            if (Mercancias.length <= 0) {
                this.$swal(Configs.configMinMercancias);
                valido =  false;
            } else{
                Mercancias.every((elem, idx) => {
                    errorObj.index = idx+1;
                    let Campos = {...entries}
                    if(elem.MaterialPeligroso === 'Si'){
                       Campos['CveMaterialPeligroso'] = 'Clave material peligroso';
                       Campos['Embalaje'] = 'Embalaje';
                    }
                    let CamposPed = {...entriesPedimentos}
                    let CamposGuia = {...entriesGuias}
                    let CamposCant= {...entriesCantTransp}

                    let campoVacio =  this.FindEmptyField(elem, Campos);
                    let pedVacio;
                    let guiaVacio;
                    let cantVacio;
                    
                    if(elem.ArrayPedimentos.length > 0){
                        elem.ArrayPedimentos.every(ped => {
                            pedVacio = this.FindEmptyField(ped,CamposPed);
                            return !pedVacio;
                        })
                    }
                    if(elem.ArrayGuias.length > 0){
                        elem.ArrayGuias.every(guia =>{
                            guiaVacio = this.FindEmptyField(guia,CamposGuia);
                            return !guiaVacio;
                        })
                    }
                    if(elem.ArrayCantTrans.length > 0){
                        elem.ArrayCantTrans.every(cantidad =>{
                            cantVacio = this.FindEmptyField(cantidad,CamposCant);
                            return !cantVacio;
                        })
                    }

                    if(campoVacio){
                        errorObj.campo = Campos[campoVacio];
                        valido = false;
                    } else if(Obj.HabPedimentos && elem.ArrayPedimentos.length <= 0){
                        this.$swal(Configs.configMinPedimentos);
                        valido = false;
                    } else if(pedVacio) {
                        errorObj.campo = CamposPed[pedVacio];
                        valido = false;
                    } else if(guiaVacio) {
                        errorObj.campo = CamposGuia[guiaVacio];
                        valido = false;
                    } else if(cantVacio){
                        errorObj.campo = CamposCant[cantVacio];
                        valido = false;
                    }

                    return valido;
                })
            }
            
            if(errorObj.campo != ''){
                let msg = `Error en mercancia ${errorObj.index}: el campo ${errorObj.campo} es obligatorio.`;
                this.$refs.mercancias.ListaMercancias.forEach(elem =>elem.Active = false)
                this.$refs.mercancias.ListaMercancias[errorObj.index-1].Active = true
                this.$toast.error(msg);
            }
            return valido;
        },
        ValidarConceptos(Conceptos){
            let valido = true;
            let errorObj = {
                index: 0,
                campo: '',
            };
            let entries ={
                // IdDetalle:      '',
                ClaveProdServ:  'Clave Servicio',
                Unidad:         'Unidad',
                ClaveObjImpuesto: 'Objeto de Impuesto',
                Descripcion:    'Descrcripción',
                Cantidad:       'Cantidad',
                Precio:         'Importe',
                // Importe:'',
            }
            if(Conceptos.length <= 0){
                let swalMsg ={...Configs.configMinMercancias};
                swalMsg.text = 'Se debe agregar al menos un concepto de factura.',
                this.$swal(swalMsg);
                valido =  false;
            } else{
                Conceptos.every((elem, idx) => {
                    errorObj.index = idx+1;
                    let Campos = {...entries}
                    let campoVacio = this.FindEmptyField(elem, Campos);
                    if(campoVacio){
                        errorObj.campo = Campos[campoVacio];
                        valido =  false;
                    }
                    if (elem.TieneIvaRet && elem.ImporteRetIva<=0){
                        errorObj.campo = 'Iva Retenido';
                        valido = false;
                    }
                    return valido;
                })
            }
            if(errorObj.campo != ''){
                let msg = `Error en concepto ${errorObj.index}: el campo ${errorObj.campo} es obligatorio.`;
                this.$toast.error(msg);
                return;
            }
            return valido;
        },
        ValidarFiguras(Figuras){
            let valido = true;
            let errorObj = {
                index: 0,
                campo: '',
            };
            let entries = {
                // IdFiguraTransp:'',
                TipoFigura:     'Tipo figura',
                NombreFigura:   'Nombre figura',
                RFCFigura:      'RFC figura',
                NumLicencia:    'N° Licencia',
                // NumRegIdTribFigura:         '',
                // ResidenciaFiscalFigura:     '',
                // IdChofer:'',
                // ArrayPartes:[],
            }
            let entriesParte = {
                    Estado:         'Estado',
                    Pais:           'Pais',
                    CodigoPostal:   'Código postal',
            }
            
            if(Figuras.length <= 0){
                let swalMsg = {...Configs.configMinMercancias};
                swalMsg.text = 'Se debe agregar al menos 1 nodo en figuras.',
                this.$swal(swalMsg);
                valido =  false;
            } else {
                Figuras.every((elem, idx) =>{
                    errorObj.index = idx+1;
                    let Campos = {...entries}
                    if(elem.ResidenciaFiscalFigura || elem.NumRegIdTribFigura){
                        Campos['NumRegIdTribFigura'] = 'N° Registro IdTributario Figura';
                        Campos['ResidenciaFiscalFigura'] = 'Residencia Fiscal Figura';
                    }
                    
                    let campoVacio =  this.FindEmptyField(elem, Campos);
                    let CamposDir = {...entriesParte}
                    let campoVacioDir;
                    if(elem.ArrayPartes.length > 0){
                        elem.ArrayPartes.every(parte =>{
                            campoVacioDir = this.FindEmptyField(parte, CamposDir);
                            return campoVacioDir == '';
                        })
                    }
                    if(campoVacio){
                        errorObj.campo = Campos[campoVacio]; 
                        valido =  false;
                    } else if(campoVacioDir){
                        errorObj.campo = CamposDir[campoVacioDir]; 
                        valido = false;
                    }
                   return valido;
                })
            }
            if(errorObj.campo != ''){
                let msg = `Error en figura ${errorObj.index}: el campo ${errorObj.campo} es obligatorio.`;
                this.$refs.figuras.ListaFiguras.forEach(elem =>elem.Active = false)
                this.$refs.figuras.ListaFiguras[errorObj.index-1].Active = true;

                this.$toast.error(msg);
                return;
            }
            return valido;
        },
        // Agrega los conceptos a las merncancias
        AgregarConMerc(arrElem, todos){
            let MercList = [];
            if(!todos){
                MercList = JSON.parse(JSON.stringify(this.$refs.mercancias.ListaMercancias));
            }
            arrElem.forEach(elem => {
                let newMerc = {
                    IdMercancia:0,
                    BienesTransp:'',
                    Descripcion:elem.Descripcion,
                    Cantidad:elem.Cantidad,
                    ClaveUnidad:'',
                    PesoEnKg:'',
                    MaterialPeligroso:'No',
                    CveMaterialPeligroso:'',
                    Embalaje:'',
                    ValorMercancia:'',
                    Moneda:'',
                    FraccionArancelaria:'',
                    ArrayPedimentos: [],
                    ArrayGuias: [],
                    ArrayCantTrans: [],
                    Active: false,
                };
                MercList.push(newMerc)
            })
            this.ListaMercancias = MercList;
        },
        // Busca campos vacios y retorna el campo vacio en caso de haber.
        FindEmptyField(Obj, RequiredFields){
            let resp = false;
            let fieldKeys = Object.keys(RequiredFields);

            let emptyField = fieldKeys.find(elem => {

                let value = Obj[elem];

                // Si es estrictamente el número 0, NO está vacío (es un ID válido)
                if (value === 0) return false;

                // Si es null, undefined o no existe la propiedad, SÍ está vacío
                if (value === null || value === undefined) return true;
                
                // Convertimos a texto de manera segura y limpiamos espacios
                return String(value).trim() === '';

                /* let input;
                // console.log(elem);
                if(typeof Obj[elem] != 'String'){
                    input = Obj[elem].toString();
                } else {
                    input = Obj[elem];
                }
                return input.trim() === '' */
            });

            if(emptyField){
                resp = emptyField;
            }
     
            return resp;
        },
        ObjectToFormData(Objeto){
            const formData = new FormData();
            // REMUEVE DATA INECESARIA
            delete Objeto.AutoCompList;
            delete Objeto.FechaSalida;
            delete Objeto.HoraSalida;
            delete Objeto.ArrRemolques;
            delete Objeto.IconSearch;
            delete Objeto.PermiteRemolque;
            delete Objeto.TranspMatPelig;
            delete Objeto.HabilitaAF;
            delete Objeto.Fraccion;
            delete Objeto.HabPedimentos;
            delete Objeto.DisableNumIdTributario;
            delete Objeto.DisableResidenciaFiscal;
            if(Objeto.TipoDocumento === 'T'){
                delete Objeto.MetodoPago;
                delete Objeto.CondicionesPago;
                delete Objeto.NumCtaPago;
                delete Objeto.IdBanco;
                delete Objeto.TipoCambio;
                delete Objeto.TipoRelacion;
                delete Objeto.IdDocRel;
            }
            Objeto.ListaConceptos.forEach(elem =>{
                delete elem.TieneIvaRet;
                delete elem.TieneIva;
                if(Objeto.TipoDocumento === 'T'){
                    delete elem.ImpDescuento;
                    delete elem.ImporteRetIva;
                    delete elem.Codigo;
                    delete elem.Isr;
                    delete elem.Iva;
                }
            });
            Objeto.ListaDestinos.forEach(elem => {
                delete elem.DisableNumIdTributario;
                delete elem.DisableResidenciaFiscal;
                delete elem.FechaSalida;
                delete elem.HoraSalida;
                delete elem.IconSearch;
            });
            Objeto.ListaMercancias.forEach(elem =>{
                delete elem.Active;
            });
            Objeto.ListaMerCanceladas.forEach(elem =>{
                delete elem.Active;
            });
            Object.entries(Objeto).forEach(([key, value]) => {
                if(Array.isArray(value)){
                    formData.append(key, JSON.stringify(value));
                } else {
                    formData.append(key, value);
                }
            })
            return formData;
        },
        Regresar() {
            this.$router.push({ name: 'cartaporte', params: { pId: this.ObjCartaporte.IdCotizacion } });
        },  
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;
        // if(this.Obj != undefined){
        //     sessionStorage.setItem('Obj',JSON.stringify(this.Obj));
        // }
        // if (JSON.parse(sessionStorage.getItem('Obj')) != undefined) {
        //     Object.assign(this.ObjCartaporte, JSON.parse(sessionStorage.getItem('Obj')));
        // }
        // this.ObjCartaporte.IdCotizacion = this.Obj.IdCotizacion;
        
        this.bus.$off('EmitReturn');
        this.bus.$off('Save_' + this.Emit);
        this.bus.$off('UpdateDistTotal');
        this.bus.$off('HabilitarFraccion');
        this.bus.$off('HabilitarPedimentos');
        this.bus.$off('UpdateHabIdUbicacion');
        this.bus.$off('AgregarConMerc');
        this.bus.$off('LimpiarMercProp');
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        this.Limpiar();
        if (this.Id && this.Obj.IdCartaPorte) {
            this.ObjCartaporte.IdCartaPorte = this.Obj.IdCartaPorte;
            this.ObjFactura.IdFactura = this.Id;
        }
        this.Recuperar();
        this.bus.$on('HabilitarFraccion', (data) => {
            this.HabilitarFraccion(data);
        })
        this.bus.$on('HabilitarPedimentos', (data) => {
            this.HabilitarPedimentos(data);
        })
        this.bus.$on('UpdateHabIdUbicacion', (data) => {
            this.HabilitarIdUbicacion(data);
        })
        this.bus.$on('UpdateDistTotal', (data) => {
            this.UpdateDistTotal(data);
        })
        this.bus.$on('AgregarConMerc', (data,todos) => {
            this.AgregarConMerc(data,todos);
        })
        this.bus.$on('Save_' + this.Emit, () => {
            this.Guardar();
        });
        this.bus.$on('LimpiarMercProp', () => {
            this.ListaMercancias = [];
        });
        this.bus.$on('EmitReturn', () => {
            this.Regresar();
        });
    }
}
</script>
